<!--
 * @Description: 活动中心审核
 * @Author: liuwp
 * @Date: 2022-09-08 17:53:44
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-21 14:49:10
-->
<template>
  <div class="yxtbiz-ac-enroll-audit">
    <div class="standard-size-16 color-gray-10">
      <div class="mb32 font-bolder">
        {{ $t('pc_biz_ac_enroller_info' /** 申请人信息 */) }}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_name' /** 姓名 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-user-name :name="detail.fullname || '--'" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-user-name :name="detail.fullname || '--'" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_dept' /**  部门 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-dept-name :name="detail.deptName || '--'" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-dept-name :name="detail.deptName || '--'" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
        <yxtf-row type="flex" class="font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroller_possion' /**岗位 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              placement="top">
              <div slot="content">
                <yxtbiz-position-name :name="detail.positionNameList || '--'" />
              </div>
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">
                <yxtbiz-position-name :name="detail.positionNameList || '--'" />
              </div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
      <div class="mb32 font-bolder">
        {{ $t('pc_biz_ac_enroll_acinfo' /** 活动信息 */) }}
        <yxtf-row type="flex" class="mv24 font-normal font-size-14">
          <yxtf-col :span="12" class="mh2 flex">
            <span class="color-gray-7 nowrap">{{ $t('pc_biz_ac_enroll_acname' /** 活动名称 */) }}：</span>
            <yxtf-tooltip
              :open-filter="true"
              :content="detail.projectName"
              placement="top">
              <div class="yxtbiz-teacher-enroll-audit_ellipsis">{{ detail.projectName || '--' }}</div>
            </yxtf-tooltip>
          </yxtf-col>
        </yxtf-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecordApi } from './service';
export default {
  name: 'YxtbizAcEnrollAudit',
  name_zh: '活动报名审核',
  props: {
    id: {
      type: String,
      default: '',
      desc: '报名id',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    this.getRecord();
  },
  methods: {
    getRecord() {
      getRecordApi(this.id).then(res => {
        this.detail = res || {};
      });
    }
  }
};
</script>
